import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'api';
import useCallbackAsync from 'hooks/useCallbackAsync';
import {
  ActiveSuggestedAction,
  SUGGESTED_ACTION_MUTE_DAYS,
} from 'router/subrouters/DataRoom/models/Dashboard';
import { removeEnterpriseSuggestedAction } from '../utils';
import { SUGGESTION_PAGE } from 'models/SuggestedActions';

const useEnterpriseThreeDotsOptions = (
  dataRoomId: string,
  suggestion: ActiveSuggestedAction,
) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const { type } = suggestion;

  const [onDismiss, isDissmising] = useCallbackAsync(async () => {
    await api.enterpriseSuggestedActions.muteSuggestedAction(
      dataRoomId,
      type,
      SUGGESTION_PAGE.ENTERPRISE_DASHBOARD,
      SUGGESTED_ACTION_MUTE_DAYS,
    );

    removeEnterpriseSuggestedAction(queryClient, dataRoomId, type);
  });

  const [onDontRemindMe, isDontReminding] = useCallbackAsync(async () => {
    await api.enterpriseSuggestedActions.muteSuggestedAction(
      dataRoomId,
      type,
      SUGGESTION_PAGE.ENTERPRISE_DASHBOARD,
    );

    removeEnterpriseSuggestedAction(queryClient, dataRoomId, type);
  });

  const threeDotsOptions = useMemo(
    () => [
      {
        label: t('dismiss'),
        disabled: isDissmising,
        onClick: onDismiss,
      },
      {
        label: t('dontRemindMeAgain'),
        disabled: isDontReminding,
        onClick: onDontRemindMe,
      },
    ],
    [isDissmising, isDontReminding, onDismiss, onDontRemindMe, t],
  );

  return {
    isDissmising,
    isDontReminding,
    threeDotsOptions,
  };
};

export default useEnterpriseThreeDotsOptions;
